import { fetchWithAuth } from "./fetchWithAuth";

const API_BASE = process.env.REACT_APP_API_BASE;
const FAVORITES_ENDPOINT = `${API_BASE}/users/me/favorites`;

const asError = async (response, fallbackMessage) => {
  if (!response) {
    throw new Error(fallbackMessage);
  }
  const text = await response.text().catch(() => "");
  throw new Error(text || fallbackMessage);
};

const toItemId = (value) => {
  const parsed = Number(value);
  if (Number.isFinite(parsed)) {
    return parsed;
  }
  return value;
};

export async function getMyFavorites() {
  const response = await fetchWithAuth(FAVORITES_ENDPOINT, { method: "GET" });
  if (!response || !response.ok) {
    await asError(response, "Неуспешно вчитување на омилени.");
  }
  return response.json();
}

export async function addFavorite({ favoriteType, itemId }) {
  const response = await fetchWithAuth(FAVORITES_ENDPOINT, {
    method: "POST",
    body: JSON.stringify({
      favorite_type: favoriteType,
      item_id: toItemId(itemId),
    }),
  });

  if (!response || !response.ok) {
    await asError(response, "Неуспешно додавање во омилени.");
  }

  return response.json().catch(() => ({}));
}

export async function removeFavorite({ favoriteType, itemId }) {
  const response = await fetchWithAuth(FAVORITES_ENDPOINT, {
    method: "DELETE",
    body: JSON.stringify({
      favorite_type: favoriteType,
      item_id: toItemId(itemId),
    }),
  });

  if (!response || !response.ok) {
    await asError(response, "Неуспешно отстранување од омилени.");
  }

  return response.json().catch(() => ({}));
}
